var _rect, _rect2, _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTutorialIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 53,
    viewBox: "0 0 39 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 40,
    width: 26,
    height: 6,
    rx: 3,
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 47,
    width: 20,
    height: 6,
    rx: 3,
    fill: "#D9D9D9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19.5,
    r: 19.5,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 40.5C17 36.5 17 27.6 17 24C17 21.5 15.5 20 13.5 20C11 20 10 22 10 23C10 25.5 12 26.5 13.5 26.5C16.7 26.5 19 26.5 20 26.5",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 40.5C23 36.5 23 27.6 23 24C23 21.5 24.5 20 26.5 20C29 20 30 22 30 23C30 25.5 28 26.5 26.5 26.5C23.3 26.5 21 26.5 20 26.5",
    stroke: "white",
    strokeWidth: 2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorialIcon);
export default __webpack_public_path__ + "static/media/tutorial-icon.c0772827e98c624766bffdffdee07762.svg";
export { ForwardRef as ReactComponent };